import * as t from 'io-ts';

import {makeEnumRuntimeType, RCardIdRef} from '../../../models/api/apiTypes';
import {RPreviewCardMerge} from '../../../models/api/previewCardMergeModel';

/*
 * Runtime types.
 */

export enum MergingStatusesEnum {
  MERGING = 'MERGING',
  MERGE_FAILED = 'MERGE_FAILED',
}
export const RMergeStatus = makeEnumRuntimeType(MergingStatusesEnum);

export const RContactDetailsPanelMergeState = t.readonly(
  t.type({
    mergeMainCardId: t.union([RCardIdRef, t.undefined]),
    mergeCardIds: t.array(RCardIdRef),
    mergeStatus: RMergeStatus,
    previewCardMerge: t.union([RPreviewCardMerge, t.undefined]),
  }),
);

/*
 * Types.
 */

export interface ContactDetailsPanelMergeState
  extends Readonly<t.TypeOf<typeof RContactDetailsPanelMergeState>> {}
